import { Toaster } from "react-hot-toast";
import SalesHeader from "../../components/sales/SalesHeader";
import SalesStats from "../../components/sales/SalesStats";
import SalesTable from "../../components/sales/SalesTable";
import Loader from "../../components/common/Loader";
import { useSalesData } from "../../hooks/useSalesData";

const SalesPage = () => {
  const { filteredOrders, isLoading, activeFilter, activeDateFilter, activeProductFilters, filterOrders, filterByDate, clearDateFilter, deleteOrder, filterByProductId, removeProductFilter, products } = useSalesData();

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }
  
  return (
    <div className="min-h-screen bg-[#F5F6FA] p-16 font-['Plus_Jakarta_Sans']">
      <Toaster position="top-right" />
      <SalesHeader />
      {filteredOrders && (
        <>
          <SalesStats summary={filteredOrders.summary} />
          <SalesTable
            filterOrders={filterOrders}
            orders={filteredOrders.orders}
            activeFilter={activeFilter}
            onOrderDeleted={deleteOrder}
            onFilterByDate={filterByDate}
            activeDateFilter={activeDateFilter}
            onRemoveDateFilter={clearDateFilter}
            products={products}
            onFilterByProductId={filterByProductId}
            activeProductFilters={activeProductFilters}
            onRemoveProductFilter={removeProductFilter}
          />
        </>
      )}
    </div>
  );
};

export default SalesPage;
